import { render, staticRenderFns } from "./SectionHeading.vue?vue&type=template&id=4d096adc&"
import script from "./SectionHeading.vue?vue&type=script&lang=js&"
export * from "./SectionHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseAvatar: require('/opt/buildhome/repo/components/base/Avatar.vue').default,BaseSubtitle: require('/opt/buildhome/repo/components/base/Subtitle.vue').default,BaseSubheading: require('/opt/buildhome/repo/components/base/Subheading.vue').default,BaseDivider: require('/opt/buildhome/repo/components/base/Divider.vue').default,BaseBody: require('/opt/buildhome/repo/components/base/Body.vue').default})
